import Router from 'next/router';

/** @param {string} trackingNumber */
export const searchCallback = (trackingNumber) => {
    Router.push(`/track?id=${trackingNumber}`);
};
